/**
 * This function handles all incomming failed responses.
 *
 * @param {Error} error - A axios error object.
 */
export default function (error) {
  const originalStackTrace = error.config?.errorContext
  if (originalStackTrace) error.stack = originalStackTrace

  if (this.$sentry) this.$sentry.captureException(error)
  throw error
}
